module.exports = __webpack_public_path__ + "static/media/EGP20.f0c6bad5.png";